function getSearchParams(param) {
  return new URL(window.location.href).searchParams.get(param);
}

export default getSearchParams;
